module.exports = __webpack_public_path__ + "img/icon_42.76d2b981.png";